"use strict";

module.exports = descend;
function descend(cb) {
  return function (a, b) {
    var cbA = cb(a);
    var cbB = cb(b);
    return cbA > cbB ? -1 : cbA < cbB ? 1 : 0;
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/descend/index.js
// module id = 193
// module chunks = 0